<template>
  <div>
    <div class="iv-list-study" v-if="type==1||type==4">
      <p class="iv-list-right-title">
        <Col :span="16"><span>{{ name }}</span></Col>
        <Col :span="8" class-name="iv-text-right iv-header-right iv-flex">
          <Select v-model="model1" style="width:200px;text-align:center;" @on-change="searchBtn">
            <Option v-for="item in optionList" :value="item.value" :key="item">{{ item.label }}</Option>
          </Select>
          <Input v-model="value" placeholder="请输入关键字" class="iv-search">
            <Button slot="append" class="iv-header-search" type="search" @click="searchBtn">搜索</Button>
          </Input>
        </Col>
      </p>
      <div class="iv-list-right-cont">
        <p class="iv-list-li" v-for="item in menuList" :key="item.id" @click="todetail(item.id)">
          <!--          <Iconfont class="iv-m-r-8 iv-zd" type="zhiding5" v-if="item.orderNum"></Iconfont>-->
          <!--          <Iconfont class="iv-m-r-8" :type="getIcon(item.infoType)"></Iconfont>-->
          <!--        <span class="iv-m-r-8 iv-fc-45 iv-fs-16 iv-fw-6">[{{item.createOrgName}}]</span>-->
          <span class="dot"></span>
          <span>[{{ item.orgName }}]</span>
          <span class="iv-list-li-title iv-fc-65 iv-fs-14 iv-m-r-24"  :title="item.title">{{ item.title }}</span>
          <span class="toTop" v-if="item.top>0"></span>
          <span>{{ getTime(item.publishTime) }}</span>
        </p>
      </div>
    </div>
    <div class="iv-list-picture" v-else>
      <!--      <p class="iv-list-right-title"><span>{{ name }}</span></p>-->
      <p class="iv-list-right-title">
        <Col :span="16"><span>{{ name }}</span></Col>
        <Col :span="8" class-name="iv-text-right iv-header-right iv-flex">
          <Select v-model="model1" style="width:200px" @on-change="searchBtn">
            <Option v-for="item in optionList" :value="item.value" :key="item">{{ item.label }}</Option>
          </Select>
          <Input v-model="value" placeholder="请输入关键字" class="iv-search">
            <Button slot="append" class="iv-header-search" type="search" @click="searchBtn">搜索</Button>
          </Input>
        </Col>
      </p>
      <div class="iv-list-right-cont">
        <div class="iv-list-li" v-for="item in menuList" :key="item.id" @click="todetail(item.id)" :class="haveLeft?'haveLeftStyle':''">
          <span>[{{ item.orgName }}]</span>
          <span class="toTop" v-if="item.top>0">置顶</span>
          <img :src="getImgPath(item.blogPic)" :alt="item.title" @error="nofind">
          <p><span class="iv-m-r-8 iv-fc-45">[{{ item.publishTime }}]</span><span :title="item.title">{{ item.title }}</span></p>
        </div>
      </div>
    </div>
<!--    列表-->
    <div v-show="type==1||type==4">
    <Page :total="total" :current="currentPage" :pageSize="pageSize5" show-sizer show-elevator show-total :page-size-opts="pageSizeOpts5"
          class="iv-list-page" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
    </div>
<!--    图片-->
    <div v-show="type==2||type==3">
      <Page :total="total" :current="currentPage" :pageSize="haveLeft?(clientWidth<=1366?pageSize3:pageSize4):(clientWidth==1366?pageSize4:pageSize5)" show-sizer show-elevator show-total :page-size-opts="haveLeft?(clientWidth<=1366?pageSizeOpts3:pageSizeOpts4):(clientWidth<=1366?pageSizeOpts4:pageSizeOpts5)"
          class="iv-list-page" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
    </div>
  </div>
</template>

<script>

import Iconfont from '@/components/iconfont'
import Page from '@/components/page'
import {timeFormat} from '@/utils'

export default {
  props: ['name', 'id', 'type','haveLeft','categoryName'],
  data() {
    return {
      title:'',
      menuList: [],
      total: 0,
      current: 1,
      currentPage: 1,
      categoryId: this.$route.query.categoryId || 'system_index',
      pageSize3: 9,
      pageSize4: 12,
      pageSize5: 15,
      once: 0,
      value: '',
      model1: true,
      optionList: [
        {
          value: true,
          label: '本组织'
        }, {
          value: false,
          label: '全部'
        }
      ],
      pageSizeOpts3:[3,6,9,12],
      pageSizeOpts4:[4,8,12,16],
      pageSizeOpts5:[5, 10, 15, 20],
      clientWidth:document.body.clientWidth
    }
  },
  created() {
    // this.title = this.$route.query.categoryName||this.name
    if (this.$route.query.categoryId && !this.$route.query.secondaryCategoryId) {
      this.initTabs(this.$route.query.categoryId)
    }
  },
  watch: {

  },
  methods: {
    searchBtn(){
      this.initTabs()
    },
    initTabs(categoryId, once) {
      // console.log('categoryId>>>>',categoryId)
      this.menuList = []
      let _categoryId=categoryId
      if (categoryId) {
        console.log('重置分页')
        this.currentPage = 1
        this.current = 1
        this.total = 0
        this.categoryId=categoryId
      }else{
        _categoryId=this.categoryId||this.$route.query.categoryId
      }
      let _pageSize
      if(this.type==2||this.type==3){
        //图片
        if(this.haveLeft){//有左侧
          if(this.clientWidth<=1366){
            _pageSize=this.pageSize3
          }else{
            _pageSize=this.pageSize4
          }
        }else{//没有左侧
          if(this.clientWidth<=1366){
            _pageSize=this.pageSize4
          }else{
            _pageSize=this.pageSize5
          }
        }

      }else{
        _pageSize=this.pageSize5
      }
      let params = {
        columnId: categoryId||_categoryId,
        current: this.current,
        pageSize:_pageSize,
        // pageSize: (this.haveLeft&&(this.type==2||this.type==3))?this.pageSize4:this.pageSize5,
        pageNum: this.currentPage,
        isDept: this.model1,
        title: this.value,
      }
      console.log("initTabs<>>>>>",params.columnId)

      // console.log(this.once != 0 && !once)
      // if (this.once != 0 && !once) {
      // return false
      // }
      this.$ajax({
        url: 'api-qixuan/cms/front/getBlogList',
        method: 'get',
        data: params,
        // headers: {
        //   'currentAuthScopeId': 'SCT4DF8CF6107B87AFC51906B562A458FB7'
        // },
      }).then(({data}) => {
        this.menuList = data.rows
        this.total = data.total || 0
        this.once = 1
        this.$emit('onloaded')
      })
    },
    getIcon(type) {
      if (type == 1) {
        return 'tuwenxinxi'
      } else if (type == 2) {
        return 'tupian'
      } else if (type == 3) {
        return 'shipin1'
      } else if (type == 4) {
        return 'icon-test2'
      } else if (type == 5) {
        return 'he_20zhiduguanli'
      }
    },
    getImgPath(blogPic) {
      return process.env.VUE_APP_BASE_DOWNLOAD_IMAGE_API + blogPic
    },
    changePage(page) {
      console.log('changePage')
      // this.$emit('on-change', page)
      this.current = page
      this.currentPage = page
      this.once = 0
      this.initTabs()
      // this.initTabs(this.$route.query.categoryId)
    },
    changePageSize(page) {
      console.log('changePageSize',page)
      // this.$emit('on-page-size-change', page)
      /*if((this.haveLeft&&(this.type==2||this.type==3))){
        this.pageSize4 = page
      }else{
        this.pageSize5 = page
      }*/
      if(this.type==2||this.type==3){
        //图片
        if(this.haveLeft){//有左侧
          if(this.clientWidth<=1366){
            this.pageSize3=page
          }else{
            this.pageSize4=page
          }
        }else{//没有左侧
          if(this.clientWidth<=1366){
            this.pageSize4=page
          }else{
            this.pageSize5=page
          }
        }

      }else{
        this.pageSize5 = page
      }
      this.once = 0
      this.initTabs()
      // this.initTabs(this.$route.query.categoryId)
    },
    getTime(d) {
      return timeFormat(d)
    },
    todetail(id, name) {
      let query = {
        infoId: id
      }
      if (this.categoryName) {
        query.categoryName = this.categoryName
      }
      const {href} = this.$router.resolve({
        name: this.$route.name == 'systemIndex' ? 'zdsyNewsDetail' : 'newsDetail',
        query: query
      })
      window.open(href, '_blank')
    },
    nofind() {
      var img = event.srcElement
      img.src = require('@/assets/images/news/default-pic.png')
      img.onerror = null
    }
  },
  components: {
    Iconfont,
    Page,
  }
}
</script>

<style lang="scss" scoped>
.iv-list-study {
  .iv-list-li {
    cursor: pointer;
  }

  .iv-zd {
    color: #FA2900;
  }

  .iv-list-right-title {
    height: 57px;
    font-size: 16px;
    line-height: 57px;
    color: rgba(0, 0, 0, 0.85);
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    margin-bottom: 9px;
    display: flex;
    align-items: center;

    span {
      display: inline-block;
      height: 57px;
      line-height: 57px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
      border-bottom: 2px solid #2373C8;
      font-size: 16px;
    }
  }

  .iv-list-right-cont {
    overflow: auto;

    .iv-list-li {
      display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
      display: -moz-box; /* 老版本语法: Firefox (buggy) */
      display: -ms-flexbox; /* 混合版本语法: IE 10 */
      display: -webkit-flex; /* 新版本语法: Chrome 21+ */
      display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
      -webkit-box-align: center;
      -moz-align-items: center;
      -webkit-align-items: center;
      align-items: center;
      padding: 20px 0;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.15);

      .dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #A9E5F9;
        margin-right: 5px;
      }

      .iv-list-li-title {
        -webkit-box-flex: 1;
        -moz-box-flex: 1;
        -webkit-flex: 1;
        -ms-flex: 1;
        flex: 1;
        font-weight: 400;

      }

      .toTop {
        background: url("~@/assets/images/icon-top.png") no-repeat;
        background-size: 18px;
        display: inline-block;
        width: 18px;
        height: 18px;
        margin-right: 5px;
      }
    }
  }
}

.iv-list-picture {
  .iv-list-li {
    cursor: pointer;
    position: relative;

    .toTop {
      position: absolute;
      left: 0;
      top: 0;
      width: 48px;
      text-align: center;
      height: 24px;
      line-height: 24px;
      background: #FF8F82;
      color: #FFFFFF;
      border-radius: 0 0 10px 0;
    }
  }

  .iv-list-picture {
    height: 100%;
  }

  .iv-list-right-title {
    height: 57px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 57px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    margin-bottom: 9px;
    display: flex;
    align-items: center;

    span {
      display: inline-block;
      height: 57px;
      line-height: 57px;
      border-bottom: 2px solid #2373C8;
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 16px;
    }
  }


}

.iv-flex {
  display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
  display: -moz-box; /* 老版本语法: Firefox (buggy) */
  display: -ms-flexbox; /* 混合版本语法: IE 10 */
  display: -webkit-flex; /* 新版本语法: Chrome 21+ */
  display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.ivu-select {
  width: 71px !important;
  position: absolute;
  text-align:center!important;
  left: 0;
  top: 1px;
  z-index: 9;
}
// /deep/.ivu-select-selected-value{
//   text-align: center;
// }
.iv-search {
  /deep/ .ivu-input {
    padding-left: 80px;
  }
}
/deep/.ivu-select-selected-value{
  text-align: center;
}
.ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
  color: #fff !important;
  height: 32px;
  border-radius: 0 4px 4px 0;
}

@media screen and (max-width: 1366px) { //1200
  .iv-list-picture .iv-list-right-cont {
    // overflow: auto;
    // height: 400px;
    div {
      display: inline-block;
      //margin-right: 47px;
      width: 261px;
      margin: 25px 13px 0 13px;

      img {
        width: 261px;
        height: 146px;
      }

      p {
        width: 261px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.64);
        height: 48px;
        line-height: 24px;
        // font-weight: bold;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }

    }

    div.haveLeftStyle{
      //width: 25%;
      margin: 25px 20px 0 20px;

    }
  }
}

@media screen and (min-width: 1367px) { //1440
  .iv-list-picture .iv-list-right-cont {
    // overflow: auto;
    // height: 400px;
    display: flex;
    flex-wrap: wrap;
    //justify-content: space-between;
    div {
      //display: inline-block;
      //margin-right: 47px;
      width: 258px;
      //width: 261px;
      margin: 25px 10px 0 10px;


      img {
        width: 258px;
        height: 145px;
      }


      p {
        width: 100%;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.64);
        height: 48px;
        line-height: 24px;
        // font-weight: bold;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }

    }
    /*div:nth-of-type(3n) {
      margin-right: 0px !important;
    }
    .haveLeftStyle{
      width: 25%;
      img{
        width: 258px;
        height: 145px;
      }
    }*/


      /*&:nth-of-type(3n) {
        margin-right: 34px !important;
      }
      &:nth-of-type(4n) {
        margin-right: 0px !important;
      }*/

  }

}
</style>
